var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.49497 1.8886L9.47247 1.9411L7.29747 6.9886H5.15997C4.64997 6.9886 4.16247 7.0936 3.71997 7.2811L5.03247 4.1461L5.06247 4.0711L5.11497 3.9511C5.12997 3.9061 5.14497 3.8611 5.16747 3.8236C6.14997 1.5511 7.25997 1.0336 9.49497 1.8886Z",
    stroke: "#2B2B2B",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5375 7.13867C13.2 7.03367 12.84 6.98867 12.48 6.98867H7.29749L9.47249 1.94117L9.49498 1.88867C9.60748 1.92617 9.71249 1.97867 9.82499 2.02367L11.4825 2.72117C12.405 3.10367 13.05 3.50117 13.44 3.98117C13.515 4.07117 13.575 4.15367 13.6275 4.25117C13.695 4.35617 13.7475 4.46117 13.7775 4.57367C13.8075 4.64117 13.83 4.70867 13.845 4.76867C14.0475 5.39867 13.9275 6.17117 13.5375 7.13867Z",
    stroke: "#2B2B2B",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1413 10.6488V12.1113C16.1413 12.2613 16.1338 12.4113 16.1263 12.5613C15.9838 15.1788 14.5213 16.4988 11.7463 16.4988H5.89629C5.71629 16.4988 5.53629 16.4838 5.36379 16.4613C2.97879 16.3038 1.70379 15.0288 1.54629 12.6438C1.52379 12.4713 1.50879 12.2913 1.50879 12.1113V10.6488C1.50879 9.14127 2.42379 7.84377 3.72879 7.28127C4.17879 7.09377 4.65879 6.98877 5.16879 6.98877H12.4888C12.8563 6.98877 13.2163 7.04127 13.5463 7.13877C15.0388 7.59627 16.1413 8.99127 16.1413 10.6488Z",
    stroke: "#2B2B2B",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.0325 4.146L3.72 7.281C2.415 7.8435 1.5 9.141 1.5 10.6485V8.451C1.5 6.321 3.015 4.5435 5.0325 4.146Z",
    stroke: "#2B2B2B",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1389 8.45074V10.6482C16.1389 8.99824 15.0439 7.59574 13.5439 7.14574C13.9339 6.17074 14.0464 5.40574 13.8589 4.76824C13.8439 4.70074 13.8214 4.63324 13.7914 4.57324C15.1864 5.29324 16.1389 6.77074 16.1389 8.45074Z",
    stroke: "#2B2B2B",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.1562ba6cd1377a34da494f38814283a3.svg";
export { ForwardRef as ReactComponent };